import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { AdminAnalytics } from './admin-analytics.types';

@Injectable({ providedIn: 'root' })
export class AdminAnalyticsService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}/api/admin/analytics`;

  /** Operations analytics for the admin dashboard (last `days` days). */
  get(days = 30): Observable<AdminAnalytics> {
    return this.http.get<AdminAnalytics>(`${this.base}/`, { params: { days } });
  }
}
